(function () {
  'use strict';

  function initializeCard(gallery) {
    if (!gallery || gallery.getAttribute('data-thf-card-ready') === 'true') return;

    var slides = Array.prototype.slice.call(gallery.querySelectorAll('[data-thf-card-slide]'));
    var modal = gallery.querySelector('[data-thf-card-lightbox]');
    var modalImage = gallery.querySelector('[data-thf-card-modal-image]');
    var currentLabel = gallery.querySelector('[data-thf-card-current]');
    var activeIndex = 0;
    var touchStartX = null;
    var lastFocus = null;

    if (!slides.length) return;
    gallery.setAttribute('data-thf-card-ready', 'true');

    function selectImage(nextIndex) {
      activeIndex = (nextIndex + slides.length) % slides.length;
      slides.forEach(function (slide, index) {
        slide.classList.toggle('is-active', index === activeIndex);
      });
      if (currentLabel) currentLabel.textContent = String(activeIndex + 1);
      if (modalImage) {
        var activeImage = slides[activeIndex].querySelector('img');
        modalImage.src = slides[activeIndex].getAttribute('data-full') || (activeImage ? activeImage.src : '');
        modalImage.alt = activeImage ? activeImage.alt : '';
      }
    }

    function previous(event) {
      if (event) {
        event.preventDefault();
        event.stopPropagation();
      }
      selectImage(activeIndex - 1);
    }

    function next(event) {
      if (event) {
        event.preventDefault();
        event.stopPropagation();
      }
      selectImage(activeIndex + 1);
    }

    function openModal(event) {
      if (!modal) return;
      event.preventDefault();
      event.stopPropagation();
      lastFocus = document.activeElement;
      selectImage(activeIndex);
      modal.hidden = false;
      document.documentElement.classList.add('thf-lightbox-open');
      var closeButton = gallery.querySelector('[data-thf-card-close]');
      if (closeButton) closeButton.focus();
    }

    function closeModal(event) {
      if (event) {
        event.preventDefault();
        event.stopPropagation();
      }
      if (!modal) return;
      modal.hidden = true;
      document.documentElement.classList.remove('thf-lightbox-open');
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    }

    function bind(selector, handler) {
      var button = gallery.querySelector(selector);
      if (button) button.addEventListener('click', handler);
    }

    bind('[data-thf-card-prev]', previous);
    bind('[data-thf-card-next]', next);
    bind('[data-thf-card-modal-prev]', previous);
    bind('[data-thf-card-modal-next]', next);
    bind('[data-thf-card-zoom]', openModal);
    bind('[data-thf-card-close]', closeModal);

    gallery.addEventListener('touchstart', function (event) {
      if (event.touches && event.touches.length === 1) {
        touchStartX = event.touches[0].clientX;
      }
    }, { passive: true });

    gallery.addEventListener('touchend', function (event) {
      var touchEndX;
      var distance;
      if (touchStartX === null || !event.changedTouches || !event.changedTouches.length) return;
      touchEndX = event.changedTouches[0].clientX;
      distance = touchEndX - touchStartX;
      touchStartX = null;
      if (Math.abs(distance) < 40 || slides.length < 2) return;
      if (distance > 0) previous();
      else next();
    }, { passive: true });

    if (modal) {
      modal.addEventListener('click', function (event) {
        if (event.target === modal) closeModal(event);
      });
    }

    gallery.addEventListener('keydown', function (event) {
      if (!modal || modal.hidden) return;
      if (event.key === 'Escape') closeModal(event);
      if (event.key === 'ArrowLeft' && slides.length > 1) previous(event);
      if (event.key === 'ArrowRight' && slides.length > 1) next(event);
    });
  }

  function initializeAll(root) {
    var scope = root || document;
    var galleries = scope.querySelectorAll ? scope.querySelectorAll('[data-thf-card-gallery]') : [];
    Array.prototype.forEach.call(galleries, initializeCard);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initializeAll(document);
    });
  } else {
    initializeAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initializeAll(event.target);
  });
})();
